//
//
//
//
//
//
//
//
import utils from './common/utils';
export default {
  data: function data() {
    return {
      oldPath: ''
    };
  },
  methods: {
    onClickLeft: function onClickLeft() {
      // this.$router.back(-1)
      var prevurl = utils.getSession('prevurl');

      if (prevurl === '/') {
        location.href = '/home';
      } else {
        this.$router.go(-1);
      }
    }
  }
};